import { useEffect, useState } from "react";

function useDebounce<T extends unknown[]>(
    func: (...args: T) => void,
    delay: number,
): (...args: T) => void {
    let timer: NodeJS.Timeout | null = null;
    return (...args: T) => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            func.call(null, ...args);
        }, delay);
    };
}

function useDebounceValue<T>(value: T, delay?: number) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(
        () => {
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay || 0);
            return () => {
                clearTimeout(handler);
            };
        },
        [value, delay]
    );
    return debouncedValue;
}

export { useDebounce, useDebounceValue }
